import ko from 'knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import MenuIcons from '../../../../app/helpers/menu-icons';
import setPassword from '../../components/setPassword/setPassword.vue';
import templateMarkup from 'raw-loader!./set-password.html';

class SetPasswordView {
    constructor(params) {
        let self = this;

        let token = ko.unwrap(params.route()).token;

        self.vueSetPassword = new Vue({
            el: '#vueSetPassword',
            vuetify,
            data: {
                token
            },
            components: {
                'set-password': setPassword
            }
        });
    }

    dispose() {
        let self = this;
        if (self.vueSetPassword) {
            self.vueSetPassword.$destroy();
            self.vueSetPassword.$el.parentNode.removeChild(self.vueSetPassword.$el);
        }
    }
}

ko.components.register('set-password-view', { template: templateMarkup, viewModel: SetPasswordView });

export default { template: templateMarkup, viewModel: SetPasswordView }
